export default __webpack_public_path__ + "static/media/uber-eats.9a5df303.svg";